// src/components/NotificationProvider.js
import { useNotifications } from '../hooks/useNotifications';
import { useFcmToken } from '../hooks/useFcmToken';

export function NotificationProvider({ children }) {
  useNotifications(); // WebSocket : notifications en direct, onglet ouvert
  useFcmToken(); // FCM : push même onglet/app fermé

  return children;
}
